const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { formatText } = require('core/i18n').i18n;
// @ components
const MortgageRequestSimpleNoteRequestStep1 = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteRequest/mortgageRequestSimpleNoteRequestStep1/mortgageRequestSimpleNoteRequestStep1');
const MortgageRequestSimpleNoteRequestStep2 = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteRequest/mortgageRequestSimpleNoteRequestStep2/mortgageRequestSimpleNoteRequestStep2');
const MortgageRequestSimpleNoteRequestStep3 = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteRequest/mortgageRequestSimpleNoteRequestStep3/mortgageRequestSimpleNoteRequestStep3');
const MortgageRequestSimpleNoteSuccessfulResult = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteRequest/mortgageRequestSimpleNoteSuccessful/mortgageRequestSimpleNoteSuccessfulResult');
const MortgageRequestError = require('components/mortgageRequest/mortgageRequestError/mortgageRequestError');
const MortgageRequestErrorCustom = require('components/mortgageRequest/mortgageRequestErrorCustom/mortgageRequestErrorCustom');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ actions
const blockedAccountsActions = require('actions/blockedAccounts');
const simpleNoteRequestAction = require('actions/mortgageRequest/mortgageRequestSimpleNoteRequest');
const getPaymentAction = require('actions/mortgageRequest/mortgageRequestPayment');
const getRequestEstates = require('actions/mortgageRequest/mortgageRequestInmuebles');
const stateActions = require('actions/mortgageRequest/mortgageRequestState');
// @ constants
const { SECOND_STEP } = require('constants/index');
const { DATOS_VIV, PROBLEMA_NS } = require('constants/mortgageRequestStates');
// @utilities
const { shouldGoToEstatesListPage } = require('utilities/mortgageHelper');

class MortgageRequestSimpleNoteRequestWizard extends React.Component {
    constructor(props) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {
        const { requestEstates, requestPayment, immEstates, history } = this.props;

        shouldGoToEstatesListPage(immEstates, history);
        requestEstates();
        requestPayment();
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    onCancel() {
        this.props.onCancel();
    }

    render() {
        const {
            finish,
            getBlockedAccounts,
            immAccounts,
            immEstates,
            immPayment,
            immSimpleNoteRequest,
            immState,
            requestState,
            resetBlockedAccounts,
            setAccount,
            setVisibleStep,
            setWillCancel,
            setTotalCost,
            summaryDocumentation,
            validateStep
        } = this.props;
        const cancelButton = true;
        const nextButton = true;
        const previousButton = true;
        const addLoadingBehaviour = true;
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish,
            cancel: this.onCancel
        };
        const immSteps = immSimpleNoteRequest.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immSimpleNoteRequest.get('visibleStep');
        const immFinalButton = 'mortgageRequestSimpleNoteRequest-finalButton';
        const isFetching = immSimpleNoteRequest.getIn(['steps', SECOND_STEP, 'setPaymentAccountInProgress']);
        const currentState = immState.get('estado');
        const isFetchingLast = immSimpleNoteRequest.get('isFetching')
       
        let content;
        if (!immEstates.get('hasBeenFetched') || !currentState) {
            return <LoadingSection />;
        } else if (immSimpleNoteRequest.get('errorReceived')) {
            content = <MortgageRequestError />
        } else if ((currentState !== DATOS_VIV && currentState !== PROBLEMA_NS) || immEstates.get('list').isEmpty()) {
            content = (
                <MortgageRequestErrorCustom
                    errorTitle={formatText('mortgageRequestSimpleNoteError-title')}
                    goBackButtonLabel={formatText('mortgageRequestSimpleNoteError-goBackLink')}
                    goBackButtonLink={'/myprofile/mortgage/panel'}
                >
                    <div className="mortgage-request-simple-note-error__text">
                        <p>{formatText('mortgageRequestSimpleNoteError-message')}</p>
                    </div>
                </MortgageRequestErrorCustom>
            );
        } else if (immSimpleNoteRequest.get('submitSuccessful')) {
            content = (
                <MortgageRequestSimpleNoteSuccessfulResult
                    requestState={requestState}
                />
            );
        } else {
            content = (
                <Wizard
                    actions={actions}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    immSteps={immSteps}
                    isFetching={isFetching}>
                    <WizardStep
                        position="first"
                        cancelButton={cancelButton}
                    >
                        <MortgageRequestSimpleNoteRequestStep1
                            immEstates={immEstates}
                            immPayment={immPayment}
                            summaryDocumentation={summaryDocumentation}
                        />
                    </WizardStep>
                    <WizardStep
                        position="middle"
                        cancelButton={cancelButton}
                        previousButton={previousButton}
                        nextButton={nextButton}
                        isLoading={isFetching}
                        >
                        <MortgageRequestSimpleNoteRequestStep2
                            immState={immState}
                            setVisibleStep={setVisibleStep}
                            getBlockedAccounts={getBlockedAccounts}
                            immSimpleNoteRequest={immSimpleNoteRequest}
                            immAccounts={immAccounts}
                            immEstates={immEstates}
                            immPayment={immPayment}
                            resetBlockedAccounts={resetBlockedAccounts}
                            setAccount={setAccount}
                            setTotalCost={setTotalCost}
                            summaryDocumentation={summaryDocumentation}
                        />
                    </WizardStep>
                    <WizardStep
                        position="last"
                        cancelButton={cancelButton}
                        previousButton={previousButton}
                        finishButton={false}
                        finalButtonDisabled={isFetchingLast}
                        isLoading={isFetchingLast}
                        addLoadingBehaviour={addLoadingBehaviour}
                        immFinalButton={immFinalButton}
                        disablePrevious={isFetchingLast}
                        disableCancel={isFetchingLast}
                       >
                        <MortgageRequestSimpleNoteRequestStep3
                            immState={immState}
                            setVisibleStep={setVisibleStep}
                            immEstates={immEstates}
                            immPayment={immPayment}
                            immAccounts={immAccounts}
                            immSimpleNoteRequest={immSimpleNoteRequest}
                            summaryDocumentation={summaryDocumentation}
                        />
                    </WizardStep>
                </Wizard>
            );
        }

        return content;

    }
}

MortgageRequestSimpleNoteRequestWizard.propTypes = {
    getBlockedAccounts: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    immSimpleNoteRequest: PropTypes.object.isRequired,
    immState: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    requestPayment: PropTypes.func.isRequired,
    requestEstates: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    setTotalCost: PropTypes.func.isRequired,
    finish: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    requestState: PropTypes.func,
    summaryDocumentation: PropTypes.object.isRequired
};

module.exports.constructor = MortgageRequestSimpleNoteRequestWizard;

module.exports.MortgageRequestSimpleNoteRequestWizard = connect(
    state => ({
        immSimpleNoteRequest: state.mortgageRequestSimpleNoteRequest,
        immAccounts: state.accounts,
        immEstates: state.mortgageRequestInmuebles,
        immPayment: state.mortgageRequestPayment,
        immState: state.mortgageRequestState,
        summaryDocumentation: state.mortgageRequestSummaryDocumentation
    }),
    {
        getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
        validateStep: simpleNoteRequestAction.validateStep,
        setVisibleStep: simpleNoteRequestAction.setVisibleStep,
        setWillCancel: simpleNoteRequestAction.setWillCancel,
        setAccount: simpleNoteRequestAction.setAccount,
        requestEstates: getRequestEstates.requestInmuebles,
        requestPayment: getPaymentAction.requestPayment,
        resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
        finish: simpleNoteRequestAction.simpleNoteRequestSignature,
        setTotalCost: simpleNoteRequestAction.setTotalCost,
        clearRequest: simpleNoteRequestAction.clearRequest,
        requestState: stateActions.requestState
    }
)(withRouter(MortgageRequestSimpleNoteRequestWizard));
